import React, { useMemo } from "react"
import PropTypes from "prop-types"
import { FunnelChart as BizFunnelChart } from "bizcharts"

import ErrorBoundary from "../../../../../../components/ErrorBoundary"

const CHART_COLORS = [
  "#5B8FF9",
  "#61DDAA",
  "#65789B",
  "#F6BD16",
  "#7262FD",
  "#78D3F8",
  "#9661BC",
  "#F6903D",
  "#E86452",
  "#36CFC9",
]

const FunnelChart = ({ graph = {} }) => {
  const graphData = graph?.graphData || []
  const invertFunnel = graph?.graphMetadata?.invertFunnel || false

  const data = useMemo(() => {
    if (!graphData?.length) return { funnelData: [], totalValue: 0 }
    const sorted = invertFunnel ? [...graphData].reverse() : graphData

    const totalValue = invertFunnel
      ? sorted[sorted.length - 1]?.value
      : sorted[0]?.value

    const funnelData = sorted.map((item, index) => {
      const value = item.value
      const percentage = totalValue > 0 ? (value / totalValue) * 100 : 0

      return {
        label: item?.label,
        value,
        percentage: percentage?.toFixed(1),
        color: CHART_COLORS[index % CHART_COLORS.length],
        ...item,
      }
    })
    return { funnelData, totalValue }
  }, [graphData, invertFunnel])

  const funnelData = data.funnelData
  const totalValue = data.totalValue

  const showPercentage = graph?.graphMetadata?.showPercentage || false

  if (!funnelData?.length) {
    return (
      <ErrorBoundary>
        <div
          style={{
            height: 360,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          No data available
        </div>
      </ErrorBoundary>
    )
  }

  return (
    <ErrorBoundary>
      <BizFunnelChart
        data={funnelData}
        xField="label"
        yField="value"
        height={360}
        padding={[20, 20, 20, 20]}
        forceFit
        color={CHART_COLORS}
        conversionTag={false}
        tooltip={{
          visible: true,
          formatter: data => {
            const percentage =
              totalValue > 0 ? ((data.value / totalValue) * 100).toFixed(1) : 0

            return {
              name: data.label,
              value: showPercentage
                ? `${data.value?.toLocaleString()} (${percentage}%)`
                : `${data.value?.toLocaleString()}`,
            }
          },
        }}
        label={{
          visible: true,
          formatter: data => `${data.label}: ${data.value?.toLocaleString()}`,
          style: {
            fill: "#000",
          },
        }}
      />
    </ErrorBoundary>
  )
}

FunnelChart.propTypes = {
  graph: PropTypes.object,
}

FunnelChart.defaultProps = {
  graph: {},
}
export default FunnelChart
